import { useLocation, Redirect } from 'react-router-dom';

export const RedirectWithSearch = ({ to }) => {
  const { search } = useLocation();

  return <Redirect to={`${to}${search}`} />;
};
